import Component from '../core/Component'
import Scroll, { scrollToElement } from '../services/Scroll'

const STATES = {
    ACTIVE: 'is-active',
    READY: 'is-ready'
}

const EMITS = {
    ITEM_OPEN: 'open'
}

class AccordionItem extends Component {

    constructor(element, options) {
        super(element)

        this.ref = {
            toggle: null,
            block: null
        }

        this.options = {
            scrollDelay: 250,
            ...options
        }

        this.checkHash()

        this.ref.block.id = ''
        this.ref.toggle?.addEventListener('click', this.handleClick)

        if (this.initializedWithHash) {
            this.open()
            scrollToElement(this.element, {mode:'auto'})
        }
    }

    handleClick = event => {
        event.preventDefault() //@TODO: doresit propisovani hashe a historii swupu

        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.element.classList.add(STATES.ACTIVE)

        this.ref.block.style.maxHeight = `${this.ref.block.scrollHeight}px`

        if (this.options.onOpen) {
            this.options.onOpen(this)
        }

        setTimeout(() => {
            scrollToElement(this.element, {mode: 'auto'})
        }, this.options.scrollDelay);
    }

    close() {
        this.element.classList.remove(STATES.ACTIVE)
        this.ref.block.style.maxHeight = `0`

        if (this.options.onClose) {
            this.options.onClose(this)
        }
    }

    resize() {
        if (this.is(STATES.ACTIVE)) {
            this.ref.block.style.maxHeight =  `${this.ref.block.scrollHeight}px`
        }
    }

    checkHash() {
        const url = window.location.href
        const id = url.substring(url.indexOf("#")).replace('#','')

        if (id && id === this.ref.block.id) {
            this.initializedWithHash = true
        }
    }
}

export default class Accordion extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }

        this.items = []
    }

    prepare() {
        this.items = this.ref.items.map(item => new AccordionItem(item, {
            onOpen: ::this.handleItemOpen
        }))

        this.element.classList.add(STATES.READY)

        Scroll.on('resize-x', this.handleResize)
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        this.items.forEach(item => item.resize())
    }

    handleItemOpen(currentItem) {
        this.items
            .filter(item => item !== currentItem)
            .forEach(item => item.close())

        this.emit(EMITS.ITEM_OPEN,currentItem)
    }
}